import React, { useState } from 'react';
import { Card, Menu, Row, Col } from 'antd';
import UserMigration from './UserMigration';
import OrgMigration from './OrgMigration';
import ItemSync from './ItemSync';
import ItemStockSync from './ItemStockSync';
import OrderMigration from './OrderMigration';

const Migrate = (props) => {
    const [current, setCurrent] = useState('user');

    if (!(props.user && props.user.admin)) {
        return <div style={{ padding: '30px' }}>Permission Denied</div>;
    }

    const items = [
        {
            label: 'Change Structure',
            key: 'grp1',
            type: 'group',
            children: [
                { label: 'User Multi Org', key: 'user' },
                { label: 'Organization Multi Seller', key: 'org' },
                { label: 'Items Sell Multi Seller', key: 'item' },
                { label: 'Items Stock Typesense', key: 'itemStock' },
            ],
        },
        {
            label: 'Migrate from Prod',
            key: 'grp2',
            type: 'group',
            children: [
                { label: 'Order Migrate', key: 'order' },
            ],
        },
    ];

    return (
        <div style={{ padding: '30px' }}>
            <Card title="Migrate Tools" bordered={false} style={{ width: '100%', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}>
                <Row gutter={24}>
                    <Col span={6} style={{ borderRight: '1px solid #f0f0f0', paddingRight: '16px' }}>
                        <Menu 
                            onClick={(e) => setCurrent(e.key)} 
                            selectedKeys={[current]} 
                            mode="inline" 
                            items={items}
                            style={{ borderRight: 'none' }}
                        />
                    </Col>
                    <Col span={18}>
                        {current === 'user' && <UserMigration db={props.db} />}
                        {current === 'org' && <OrgMigration db={props.db} />}
                        {current === 'item' && <ItemSync db={props.db} />}
                        {current === 'itemStock' && <ItemStockSync db={props.db} />}
                        {current === 'order' && <OrderMigration db={props.db} />}
                    </Col>
                </Row>
            </Card>
        </div>
    );
};

export default Migrate;
